// Futuramente este contrato poderá vir de uma API, sendo necessario mudar somente o endPoint
import { marginContract } from 'components/TransferSecurity/contracts'

const getMarginAccountContract = () => marginContract

export default getMarginAccountContract
